<template>
  <div>
    <vs-table :data="resumo" stripe>
      <!-- Colunas -->
      <template slot="thead">
        <vs-th
          v-for="(nomeColuna, index) in colunas"
          :key="index"
          class="text-xs"
          >{{ nomeColuna }}</vs-th
        >
      </template>

      <!-- Valores -->
      <template slot-scope="{ data }">
        <vs-tr v-for="(item, indexItem) in data" :key="indexItem">
          <td
            v-for="(valor, indexValor) in item"
            :key="indexValor"
            class="text-xs"
          >
            {{ valor ? valor : '----' }}
          </td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>
<script>
export default {
  props: ['dadosResumo'],

  watch: {
    dadosResumo(value) {
      this.resumo = value;
      this.colunas = Object.keys(this.resumo[0]);
    },
  },

  data() {
    return {
      resumo: [],
      colunas: [],
    };
  },

  methods: {},
  mounted() {
    this.resumo = this.dadosResumo;
    this.colunas = Object.keys(this.resumo[0]);
  },
};
</script>
